export default "__VITE_ASSET__D7oa4TUI__"